import React from 'react';
import PropTypes from 'prop-types';
// Utils
import { ImageProps, RichTextPropTypes } from '../../prop-types';
import { propLink } from '../link-handler';
import { consistentString } from '../../utils/content-formatting';
// Components
import CTA from '../cta';
import LinkBox from '../link-box';
import RichText from '../rich-text';
// Styles
import {
  LinkBoxWrapper,
  TextWrapper,
  ImageWrapper,
  StyledContainer,
} from './styles';

const AdviceLinks = ({
  introText,
  image,
  adviceLinks,
  adviceCta,
  alignImage,
  removeMarginBottom,
}) => (
  <StyledContainer $removeMarginBottom={removeMarginBottom}>
    {introText && (
      <TextWrapper>
        <RichText richText={introText} />
      </TextWrapper>
    )}
    {image && (
      <ImageWrapper $image={image} $alignImage={consistentString(alignImage)} />
    )}
    <LinkBoxWrapper data-testid="link-box-wrapper">
      <LinkBox {...adviceLinks} />
    </LinkBoxWrapper>
    {adviceCta && (
      <CTA bg={consistentString(adviceCta.ctaColor)} link={adviceCta.link}>
        {adviceCta.buttonText}
      </CTA>
    )}
  </StyledContainer>
);

AdviceLinks.propTypes = {
  introText: RichTextPropTypes,
  image: ImageProps,
  alignImage: PropTypes.oneOf(['Top', 'Center', 'Bottom']),
  adviceLinks: PropTypes.object.isRequired,
  adviceCta: PropTypes.shape({
    ctaColor: PropTypes.string.isRequired,
    link: propLink.isRequired,
    buttonText: PropTypes.string.isRequired,
  }),
  removeMarginBottom: PropTypes.bool,
};

export default AdviceLinks;

export const AdviceLinksAssembly = ({ contentfulData }) => (
  <AdviceLinks
    introText={contentfulData.introText}
    image={contentfulData.image}
    alignImage={contentfulData.alignImage}
    adviceLinks={contentfulData.adviceLinks}
    adviceCta={contentfulData.adviceCta}
    removeMarginBottom={contentfulData.removeMarginBottom}
  />
);

AdviceLinksAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
